import { ApplicationStatus } from 'api/btlApplicationForm/types';
import { BtlApplicationFormPageEnum } from './types';

export const ALL_STEPS_WITHOUT_DOCUMENTS: BtlApplicationFormPageEnum[] = [
  BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
  BtlApplicationFormPageEnum.APPLICANTS,
  BtlApplicationFormPageEnum.PRODUCT,
  BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  BtlApplicationFormPageEnum.TOP_SLICING,
  BtlApplicationFormPageEnum.SOLICITORS,
  BtlApplicationFormPageEnum.BANK_DETAILS,
  BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION,
];

export const ALL_STEPS_WITHOUT_COMMUNICATION_AND_DOCUMENTS: BtlApplicationFormPageEnum[] = [
  BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
  BtlApplicationFormPageEnum.APPLICANTS,
  BtlApplicationFormPageEnum.PRODUCT,
  BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  BtlApplicationFormPageEnum.TOP_SLICING,
  BtlApplicationFormPageEnum.SOLICITORS,
  BtlApplicationFormPageEnum.BANK_DETAILS,
  BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION,
];

export const ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER_AND_COMMUNICATION: BtlApplicationFormPageEnum[] = [
  BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
  BtlApplicationFormPageEnum.APPLICANTS,
  BtlApplicationFormPageEnum.PRODUCT,
  BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  BtlApplicationFormPageEnum.TOP_SLICING,
  BtlApplicationFormPageEnum.SOLICITORS,
  BtlApplicationFormPageEnum.BANK_DETAILS,
  BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION,
  BtlApplicationFormPageEnum.DOCUMENTS,
];

export const ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER: BtlApplicationFormPageEnum[] = [
  BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
  BtlApplicationFormPageEnum.APPLICANTS,
  BtlApplicationFormPageEnum.PRODUCT,
  BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  BtlApplicationFormPageEnum.TOP_SLICING,
  BtlApplicationFormPageEnum.SOLICITORS,
  BtlApplicationFormPageEnum.BANK_DETAILS,
  BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION,
  BtlApplicationFormPageEnum.COMMUNICATION,
  BtlApplicationFormPageEnum.DOCUMENTS,
];

export const ALL_STEPS_WITHOUT_POST_OFFER: BtlApplicationFormPageEnum[] = [
  BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
  BtlApplicationFormPageEnum.APPLICANTS,
  BtlApplicationFormPageEnum.PRODUCT,
  BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  BtlApplicationFormPageEnum.TOP_SLICING,
  BtlApplicationFormPageEnum.SOLICITORS,
  BtlApplicationFormPageEnum.BANK_DETAILS,
  BtlApplicationFormPageEnum.COMMUNICATION,
  BtlApplicationFormPageEnum.DOCUMENTS,
  BtlApplicationFormPageEnum.VALUATION,
  BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION,
];

export const ALL_STEPS: BtlApplicationFormPageEnum[] = [
  BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
  BtlApplicationFormPageEnum.APPLICANTS,
  BtlApplicationFormPageEnum.PRODUCT,
  BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  BtlApplicationFormPageEnum.TOP_SLICING,
  BtlApplicationFormPageEnum.SOLICITORS,
  BtlApplicationFormPageEnum.BANK_DETAILS,
  BtlApplicationFormPageEnum.COMMUNICATION,
  BtlApplicationFormPageEnum.DOCUMENTS,
  BtlApplicationFormPageEnum.VALUATION,
  BtlApplicationFormPageEnum.POST_OFFER,
  BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION,
];

export const STATUS_TO_STEPS: Partial<Record<ApplicationStatus, BtlApplicationFormPageEnum[]>> = {
  [ApplicationStatus.NEW]: [
    BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
    BtlApplicationFormPageEnum.APPLICANTS,
    BtlApplicationFormPageEnum.PRODUCT,
    BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
    BtlApplicationFormPageEnum.TOP_SLICING,
    BtlApplicationFormPageEnum.SUBMIT_DIP,
  ],
  [ApplicationStatus.DIP_SUBMITTED]: [
    BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
    BtlApplicationFormPageEnum.APPLICANTS,
    BtlApplicationFormPageEnum.PRODUCT,
    BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
    BtlApplicationFormPageEnum.TOP_SLICING,
  ],
  [ApplicationStatus.REVIEWING_DIP]: [
    BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
    BtlApplicationFormPageEnum.APPLICANTS,
    BtlApplicationFormPageEnum.PRODUCT,
    BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
    BtlApplicationFormPageEnum.TOP_SLICING,
  ],
  [ApplicationStatus.DIP_ACCEPTED]: ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER_AND_COMMUNICATION,
  [ApplicationStatus.DIP_DECLINED]: ALL_STEPS_WITHOUT_DOCUMENTS,
  [ApplicationStatus.DIP_EXPIRED]: ALL_STEPS_WITHOUT_DOCUMENTS,
  [ApplicationStatus.APPLICATION_SUBMITTED]: ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER,
  [ApplicationStatus.BTL_APPLICATION_SUBMITTED]: ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER,
  [ApplicationStatus.RECOMMENDED]: ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER,
  [ApplicationStatus.FIS_ISSUED]: ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER,
  [ApplicationStatus.FEES_PAID]: ALL_STEPS_WITHOUT_POST_OFFER,
  [ApplicationStatus.REVIEWING_APPLICATION]: ALL_STEPS_WITHOUT_POST_OFFER,
  [ApplicationStatus.OFFER_ISSUED]: ALL_STEPS_WITHOUT_POST_OFFER,
  [ApplicationStatus.OFFER_BEING_REVISED]: ALL_STEPS_WITHOUT_POST_OFFER,
  [ApplicationStatus.OFFER_ACCEPTED]: ALL_STEPS,
  [ApplicationStatus.OFFER_EXPIRED]: ALL_STEPS_WITHOUT_POST_OFFER,
  [ApplicationStatus.APPLICATION_DECLINED]: ALL_STEPS,
  [ApplicationStatus.COMPLETION]: ALL_STEPS,
};

export const STATUS_TO_LABELS: Partial<Record<ApplicationStatus, string>> = {
  [ApplicationStatus.NEW]: 'New',
  [ApplicationStatus.DIP_SUBMITTED]: 'DIP Submitted',
  [ApplicationStatus.REVIEWING_DIP]: 'Reviewing DIP',
  [ApplicationStatus.DIP_ACCEPTED]: 'DIP Accepted',
  [ApplicationStatus.DIP_DECLINED]: 'DIP Declined',
  [ApplicationStatus.DIP_EXPIRED]: 'DIP Expired',
  [ApplicationStatus.BTL_APPLICATION_SUBMITTED]: 'BTL Application Submitted',
  [ApplicationStatus.FIS_ISSUED]: 'FIS Issued',
  [ApplicationStatus.FEES_PAID]: 'Fees Paid',
  [ApplicationStatus.REVIEWING_APPLICATION]: 'Reviewing Application',
  [ApplicationStatus.OFFER_ISSUED]: 'Offer Issued',
  [ApplicationStatus.OFFER_ACCEPTED]: 'Offer Accepted',
  [ApplicationStatus.OFFER_EXPIRED]: 'Offer Expired',
  [ApplicationStatus.APPLICATION_DECLINED]: 'Application Declined',
  [ApplicationStatus.COMPLETION]: 'Completion',
};

export const STATUS_TO_CAN_RUN_AFFORDABILITY: Partial<Record<ApplicationStatus, boolean>> = {
  [ApplicationStatus.NEW]: true,
  [ApplicationStatus.DIP_SUBMITTED]: false,
  [ApplicationStatus.REVIEWING_DIP]: false,
  [ApplicationStatus.DIP_ACCEPTED]: true,
  [ApplicationStatus.DIP_DECLINED]: false,
  [ApplicationStatus.DIP_EXPIRED]: false,
  [ApplicationStatus.BTL_APPLICATION_SUBMITTED]: false,
  [ApplicationStatus.FIS_ISSUED]: false,
  [ApplicationStatus.FEES_PAID]: false,
  [ApplicationStatus.REVIEWING_APPLICATION]: false,
  [ApplicationStatus.OFFER_ISSUED]: false,
  [ApplicationStatus.OFFER_ACCEPTED]: false,
  [ApplicationStatus.OFFER_EXPIRED]: false,
  [ApplicationStatus.APPLICATION_DECLINED]: false,
  [ApplicationStatus.COMPLETION]: false,
};

export const isDipAcceptedOrLater = (status?: ApplicationStatus): boolean => {
  if (!status) return false;

  const statusesDipAcceptedAndAfter: ApplicationStatus[] = [
    ApplicationStatus.DIP_ACCEPTED,
    ApplicationStatus.AWAITING_PROPERTY,
    ApplicationStatus.PROPERTY_SUBMITTED,
    ApplicationStatus.BOOKING_PRE_ADVICE,
    ApplicationStatus.PRE_ADVICE_BOOKED,
    ApplicationStatus.ADVICE_BOOKED,
    ApplicationStatus.PRODUCT_NOT_SUITABLE,
    ApplicationStatus.RECOMMENDED,
    ApplicationStatus.FIS_ISSUED,
    ApplicationStatus.PAYMENT_DUE,
    ApplicationStatus.APPLICATION_SUBMITTED,
    ApplicationStatus.BTL_APPLICATION_SUBMITTED,
    ApplicationStatus.FEES_PAID,
    ApplicationStatus.REVIEWING_APPLICATION,
    ApplicationStatus.PROPERTY_DECLINED,
    ApplicationStatus.APPLICATION_DECLINED,
    ApplicationStatus.OFFER_ISSUED,
    ApplicationStatus.OFFER_ACCEPTED,
    ApplicationStatus.OFFER_EXPIRED,
    ApplicationStatus.OFFER_BEING_REVISED,
    ApplicationStatus.COMPLETION,
  ];

  return statusesDipAcceptedAndAfter.includes(status);
};

export const isApplicationSubmittedOrLater = (status?: ApplicationStatus): boolean => {
  if (!status) return false;

  const statusesApplicationSubmittedAndAfter: ApplicationStatus[] = [
    ApplicationStatus.APPLICATION_SUBMITTED,
    ApplicationStatus.BTL_APPLICATION_SUBMITTED,
    ApplicationStatus.FIS_ISSUED,
    ApplicationStatus.PAYMENT_DUE,
    ApplicationStatus.FEES_PAID,
    ApplicationStatus.REVIEWING_APPLICATION,
    ApplicationStatus.PROPERTY_DECLINED,
    ApplicationStatus.APPLICATION_DECLINED,
    ApplicationStatus.OFFER_ISSUED,
    ApplicationStatus.OFFER_ACCEPTED,
    ApplicationStatus.OFFER_EXPIRED,
    ApplicationStatus.OFFER_BEING_REVISED,
    ApplicationStatus.COMPLETION,
  ];

  return statusesApplicationSubmittedAndAfter.includes(status);
};

export const hasValuationStep = (status?: ApplicationStatus): boolean => {
  if (!status) return false;
  const steps = STATUS_TO_STEPS[status];
  return steps?.includes(BtlApplicationFormPageEnum.VALUATION) ?? false;
};

export const hasPostOfferStep = (status?: ApplicationStatus): boolean => {
  if (!status) return false;
  const steps = STATUS_TO_STEPS[status];
  return steps?.includes(BtlApplicationFormPageEnum.POST_OFFER) ?? false;
};

export const getValuationStepIndex = (
  status?: ApplicationStatus,
  isTopSlicing?: boolean,
  isCustomerEvidenceEnabled?: boolean,
  isCommunicationTabEnabled?: boolean,
): number | undefined => {
  if (!status || !hasValuationStep(status)) return undefined;

  const bankDetailsIndex = isTopSlicing ? 6 : 5;
  let currentIndex = bankDetailsIndex;

  const hasDocuments = hasDocumentsStep(status);
  const hasCommunication = isApplicationSubmittedOrLater(status);

  // Add COMMUNICATION if it should be shown and flag is enabled
  if (hasCommunication && isCommunicationTabEnabled) {
    currentIndex += 1;
  }

  // Add DOCUMENTS if it should be shown
  if (isCustomerEvidenceEnabled && hasDocuments) {
    currentIndex += 1;
  }

  // VALUATION comes after BANK_DETAILS, optionally COMMUNICATION, and optionally DOCUMENTS
  return currentIndex + 1;
};

export const getPostOfferStepIndex = (
  status?: ApplicationStatus,
  isTopSlicing?: boolean,
  isCustomerEvidenceEnabled?: boolean,
  isCommunicationTabEnabled?: boolean,
): number | undefined => {
  if (!status || !hasPostOfferStep(status)) return undefined;

  const valuationIndex = getValuationStepIndex(
    status,
    isTopSlicing,
    isCustomerEvidenceEnabled,
    isCommunicationTabEnabled,
  );
  if (!valuationIndex) return undefined;

  // POST_OFFER comes after VALUATION
  return valuationIndex + 1;
};

export const hasDocumentsStep = (status?: ApplicationStatus): boolean => {
  if (!status) return false;
  const steps = STATUS_TO_STEPS[status];
  return steps?.includes(BtlApplicationFormPageEnum.DOCUMENTS) ?? false;
};

export const getNextStep = (
  currentStep: BtlApplicationFormPageEnum,
  status?: ApplicationStatus,
  isCustomerEvidenceEnabled?: boolean,
  isCommunicationTabEnabled?: boolean,
): BtlApplicationFormPageEnum | undefined => {
  if (!status) return undefined;
  const steps = STATUS_TO_STEPS[status];
  if (!steps) return undefined;

  // Filter out COMMUNICATION if feature flag is disabled
  const filteredSteps = isCommunicationTabEnabled
    ? steps
    : steps.filter(step => step !== BtlApplicationFormPageEnum.COMMUNICATION);

  // BANK_DETAILS -> COMMUNICATION (if COMMUNICATION exists in steps and flag is enabled), otherwise -> DOCUMENTS (if exists), otherwise next step
  if (currentStep === BtlApplicationFormPageEnum.BANK_DETAILS) {
    if (isCommunicationTabEnabled && steps.includes(BtlApplicationFormPageEnum.COMMUNICATION)) {
      return BtlApplicationFormPageEnum.COMMUNICATION;
    }
    // If COMMUNICATION doesn't exist, check for DOCUMENTS
    if (isCustomerEvidenceEnabled && steps.includes(BtlApplicationFormPageEnum.DOCUMENTS)) {
      return BtlApplicationFormPageEnum.DOCUMENTS;
    }
    // Fallback to default behavior - get next step in order
    const currentIndex = filteredSteps.indexOf(currentStep);
    if (currentIndex !== -1 && currentIndex < filteredSteps.length - 1) {
      return filteredSteps[currentIndex + 1];
    }
    return undefined;
  }

  // COMMUNICATION -> DOCUMENTS (if isCustomerEvidenceEnabled and DOCUMENTS exists), otherwise -> ADDITIONAL_INFORMATION
  if (currentStep === BtlApplicationFormPageEnum.COMMUNICATION) {
    if (isCustomerEvidenceEnabled && steps.includes(BtlApplicationFormPageEnum.DOCUMENTS)) {
      return BtlApplicationFormPageEnum.DOCUMENTS;
    }
    // If no documents, go to ADDITIONAL_INFORMATION
    if (steps.includes(BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION)) {
      return BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION;
    }
    // Fallback to next step in order
    const currentIndex = filteredSteps.indexOf(currentStep);
    if (currentIndex !== -1 && currentIndex < filteredSteps.length - 1) {
      return filteredSteps[currentIndex + 1];
    }
    return undefined;
  }

  // DOCUMENTS -> ADDITIONAL_INFORMATION
  if (currentStep === BtlApplicationFormPageEnum.DOCUMENTS) {
    if (steps.includes(BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION)) {
      return BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION;
    }
    // Fallback to next step in order
    const currentIndex = filteredSteps.indexOf(currentStep);
    if (currentIndex !== -1 && currentIndex < filteredSteps.length - 1) {
      return filteredSteps[currentIndex + 1];
    }
    return undefined;
  }

  // Default behavior: get next step in order
  const currentIndex = filteredSteps.indexOf(currentStep);
  if (currentIndex === -1 || currentIndex === filteredSteps.length - 1) return undefined;

  return filteredSteps[currentIndex + 1];
};

export const getPreviousStep = (
  currentStep: BtlApplicationFormPageEnum,
  status?: ApplicationStatus,
  isCustomerEvidenceEnabled?: boolean,
  isCommunicationTabEnabled?: boolean,
): BtlApplicationFormPageEnum | undefined => {
  if (!status) return undefined;
  const steps = STATUS_TO_STEPS[status];
  if (!steps) return undefined;

  // Filter out COMMUNICATION if feature flag is disabled
  const filteredSteps = isCommunicationTabEnabled
    ? steps
    : steps.filter(step => step !== BtlApplicationFormPageEnum.COMMUNICATION);

  // COMMUNICATION -> BANK_DETAILS (always)
  if (currentStep === BtlApplicationFormPageEnum.COMMUNICATION) {
    return BtlApplicationFormPageEnum.BANK_DETAILS;
  }

  // DOCUMENTS -> COMMUNICATION (if COMMUNICATION exists in filtered steps and flag is enabled), otherwise -> BANK_DETAILS
  if (currentStep === BtlApplicationFormPageEnum.DOCUMENTS) {
    // Only return COMMUNICATION if flag is enabled AND it exists in filtered steps
    if (isCommunicationTabEnabled && filteredSteps.includes(BtlApplicationFormPageEnum.COMMUNICATION)) {
      return BtlApplicationFormPageEnum.COMMUNICATION;
    }
    // Always return BANK_DETAILS if COMMUNICATION is not available
    return BtlApplicationFormPageEnum.BANK_DETAILS;
  }

  // ADDITIONAL_INFORMATION -> POST_OFFER (if exists), otherwise -> VALUATION (if exists), otherwise -> DOCUMENTS (if exists), otherwise -> COMMUNICATION (if exists), otherwise previous step
  if (currentStep === BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION) {
    // Check POST_OFFER first (it comes right before ADDITIONAL_INFORMATION)
    if (hasPostOfferStep(status)) {
      return BtlApplicationFormPageEnum.POST_OFFER;
    }
    // Then check VALUATION
    if (hasValuationStep(status)) {
      return BtlApplicationFormPageEnum.VALUATION;
    }
    // Then check DOCUMENTS
    if (isCustomerEvidenceEnabled && steps.includes(BtlApplicationFormPageEnum.DOCUMENTS)) {
      return BtlApplicationFormPageEnum.DOCUMENTS;
    }
    // Then check COMMUNICATION
    if (isCommunicationTabEnabled && steps.includes(BtlApplicationFormPageEnum.COMMUNICATION)) {
      return BtlApplicationFormPageEnum.COMMUNICATION;
    }
    // Fallback to previous step
    const currentIndex = filteredSteps.indexOf(currentStep);
    if (currentIndex > 0) {
      return filteredSteps[currentIndex - 1];
    }
    return undefined;
  }

  // Default behavior: get previous step in order
  const currentIndex = filteredSteps.indexOf(currentStep);
  if (currentIndex <= 0) return undefined;

  return filteredSteps[currentIndex - 1];
};

export const getDocumentsStepIndex = (
  status?: ApplicationStatus,
  isTopSlicing?: boolean,
  isCustomerEvidenceEnabled?: boolean,
  isCommunicationTabEnabled?: boolean,
): number | undefined => {
  if (!status || !isCustomerEvidenceEnabled) return undefined;

  const bankDetailsIndex = isTopSlicing ? 6 : 5;
  let currentIndex = bankDetailsIndex;

  // Add COMMUNICATION if it should be shown and flag is enabled
  const hasCommunication = isApplicationSubmittedOrLater(status);
  if (hasCommunication && isCommunicationTabEnabled) {
    currentIndex += 1;
  }

  // DOCUMENTS comes after BANK_DETAILS and optionally COMMUNICATION
  return currentIndex + 1;
};

export const getAdditionalInformationStepIndex = (
  status?: ApplicationStatus,
  isTopSlicing?: boolean,
  isCustomerEvidenceEnabled?: boolean,
  isCommunicationTabEnabled?: boolean,
): number | undefined => {
  if (!status) return undefined;

  const bankDetailsIndex = isTopSlicing ? 6 : 5;
  let currentIndex = bankDetailsIndex;

  const hasDocuments = hasDocumentsStep(status);
  const hasCommunication = isApplicationSubmittedOrLater(status);

  // Add COMMUNICATION if it should be shown and flag is enabled
  if (hasCommunication && isCommunicationTabEnabled) {
    currentIndex += 1;
  }

  // Add DOCUMENTS if it should be shown
  if (isCustomerEvidenceEnabled && hasDocuments) {
    currentIndex += 1;
  }

  // Add VALUATION if it should be shown
  if (hasValuationStep(status)) {
    currentIndex += 1;
    // Add POST_OFFER if it should be shown
    if (hasPostOfferStep(status)) {
      currentIndex += 1;
    }
  }

  // ADDITIONAL_INFORMATION comes after all the above
  return currentIndex + 1;
};
